import { render, staticRenderFns } from "./Rejection.vue?vue&type=template&id=45c6824a&scoped=true"
import script from "./Rejection.vue?vue&type=script&lang=js"
export * from "./Rejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6824a",
  null
  
)

export default component.exports